import Vue from 'vue';
import Vuex from 'vuex';


// System modules
import moduleAuth from './auth';
import moduleCompany from './company';
import moduleRating from './rating';


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: moduleAuth,   
    company: moduleCompany,
    rating: moduleRating
  },
  strict: process.env.DEV,
});
